/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { jsx } from '@compiled/react';
import { useIntl } from 'react-intl-next';
import { di } from 'react-magnetic-di';

import { DropdownItem } from '@atlaskit/dropdown-menu';
import UploadIcon from '@atlaskit/icon/core/upload';
import { useAnalytics } from '@atlassian/conversation-assistant-instrumentation';
import { type AssistanceServiceInputParam } from '@atlassian/conversation-assistant-service';

import { useConversationFiles } from '../../../controllers/conversation-files';
import { MAX_FILES } from '../../../controllers/conversation-files/constants';

import messages from './messages';

export const FileUploadDropdownItem = ({
	onClick,
	assistanceServiceParams,
	attachmentsStoreKey,
}: {
	onClick: () => void;
	assistanceServiceParams: AssistanceServiceInputParam['assistanceServiceParams'];
	attachmentsStoreKey: string;
}) => {
	di(useConversationFiles);
	const { formatMessage } = useIntl();
	const { sendAnalyticsEvent } = useAnalytics();
	const { files } = useConversationFiles({
		assistanceServiceParams: {
			...assistanceServiceParams,
			touchpointSource: 'fileUploadButton',
		},
		key: attachmentsStoreKey,
	});
	const isMaxFilesReached = files.length >= MAX_FILES;

	return (
		<DropdownItem
			testId="file-upload-dropdown-item"
			isDisabled={isMaxFilesReached}
			description={
				isMaxFilesReached
					? formatMessage(messages.fileUploadButtonMaxFilesLabel, {
							maxFiles: MAX_FILES,
						})
					: undefined
			}
			elemBefore={<UploadIcon label="" />}
			onClick={() => {
				sendAnalyticsEvent({
					action: 'clicked',
					actionSubject: 'button',
					actionSubjectId: 'chatFileUploadButton',
				});

				onClick();
			}}
		>
			{formatMessage(messages.fileUploadButtonLabel)}
		</DropdownItem>
	);
};
